const urls = {
    initCheckout:() => `${process.env.BASE_API_URL}/api/usr/v2/plans/initCheckout`,
    plansPending:(id) => `${process.env.BASE_API_URL}/api/usr/v2/plans/pending/${id}`
}

export { urls }